const BASE_DOMAINS = [
  'named.com',
  'nmd.co',
  'xn--950bo4em5v.co',
  'named.net',
  'named2.net',
  'named2.kr',
  '88named.com',
  'namedhub.com',
  '1named.com',
  // add more domains here
];

function normalizeHostname(hostname) {
  return String(hostname || '').toLowerCase();
}

/**
 * Returns matched base domain by suffix (e.g. m.stage.named.com -> named.com).
 * If none matches, returns defaultBaseDomain.
 */
function getBaseDomainFromHostname(hostname, defaultBaseDomain = 'nmd.co') {
  const h = normalizeHostname(hostname);
  for (let i = 0; i < BASE_DOMAINS.length; i++) {
    const domain = BASE_DOMAINS[i];
    if (h === domain || h.endsWith(`.${domain}`)) {
      return domain;
    }
  }
  return defaultBaseDomain;
}

/**
 * Production-like hostnames used by the mobile FE (no dev/docker/localhost/stage).
 * Used to decide whether to send test flags (e.g. medal exchange).
 */
function isRealProductionHostname(hostname) {
  const h = normalizeHostname(hostname);
  if (!h) return false;
  if (h === 'localhost') return false;
  if (h.includes('dev') || h.includes('docker')) return false;
  if (h.startsWith('m-stage.') || h.startsWith('stage.')) return false;
  return BASE_DOMAINS.some((d) => h === d || h === `m.${d}`);
}

module.exports = {
  BASE_DOMAINS,
  getBaseDomainFromHostname,
  isRealProductionHostname,
};

